import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Components
import FilterList from '../filterList';
import FilterFooter from '../filterFooter';
var FilterContent = function FilterContent(props) {
  var onAction = props.onAction,
    fields = props.fields,
    sections = props.sections,
    values = props.values,
    isModified = props.isModified,
    showAddFilter = props.showAddFilter,
    showReset = props.showReset,
    isReadOnly = props.isReadOnly;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterList, {
    onAction: onAction,
    fields: fields,
    sections: sections,
    values: values,
    isReadOnly: isReadOnly
  }), /*#__PURE__*/React.createElement(FilterFooter, {
    showReset: showReset,
    onAction: onAction,
    isModified: isModified,
    showAddFilter: showAddFilter,
    isReadOnly: isReadOnly
  }));
};
FilterContent.propTypes = {
  onAction: PropTypes.func,
  fields: PropTypes.object,
  sections: PropTypes.array,
  values: PropTypes.object,
  isModified: PropTypes.bool,
  showAddFilter: PropTypes.bool,
  showReset: PropTypes.bool,
  isReadOnly: PropTypes.bool
};
FilterContent.defaultProps = {
  onAction: _noop,
  fields: EMPTY_OBJECT,
  sections: EMPTY_ARRAY,
  values: EMPTY_OBJECT,
  isModified: true,
  showAddFilter: true,
  showReset: true,
  isReadOnly: false
};
export default FilterContent;